module.exports = __webpack_public_path__ + "static/media/stenobothrus_crassipes.9860544f.jpg";